// import React from 'react';

import { isEmpty } from '../helper-utils/appUtils';

function GdsMeals(supplier, currency) {
  const cur = isEmpty(currency) ? 'INR' : currency;
  const uapimeals = [
    {
      ssrcode: 'AVML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname:
        ' Asian Vegetarian Meal - A flavourful vegetarian alternative, with likely standards being curry dishes. Expect rice, noodles, fruit, vegetables and milk products - but no meat, fish or eggs.',
    },
    {
      ssrcode: 'BBML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'Baby Meal',
    },
    {
      ssrcode: 'CAKE',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname:
        'Birthday Cake - airlines vary in their offering of birthday cakes. Some charge and some are complimentary when pre-ordered.',
    },
    {
      ssrcode: 'BLML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname:
        'Bland Meal- some critics say all airline meals are bland but in this case, the meal is designed for passengers who may have ulcers, heartburn, nausea, vomiting, diarrhea or have undergone stomach or intestinal surgery. Includes foods that are soft, not very spicy, and low in fiber.',
    },
    {
      ssrcode: 'CLML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'Celebration Cake Meal',
    },
    {
      ssrcode: 'DBML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'Diabetic Meal- Sugar reduced items only',
    },
    {
      ssrcode: 'FPML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'Fruit Platter Meal - Seasonal fresh fruit',
    },
    {
      ssrcode: 'GFML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname:
        'Gluten Intolerant Meal- No wheat, rye, barley or other gluten-based products',
    },
    {
      ssrcode: 'HFML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'High Fibre Meal',
    },
    {
      ssrcode: 'HNML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname:
        'Hindu Non-Vegetarian Meal- Traditionally flavoured meals that will likely contain lamb, poultry, fish or milk but absent of beef, veal or pork.',
    },
    {
      ssrcode: 'JPML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'Japanese Meal (served on Japan Airlines only)',
    },
    {
      ssrcode: 'JNML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: "unior Meal. Not a kid's meal, but not an adult meal, either.",
    },
    {
      ssrcode: 'KSML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname:
        'Kosher Meal- Confirmed to be prepared to meet strict Jewish Kosher cooking rules.',
    },
    {
      ssrcode: 'KSMLS',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'Kosher Meal (Snack size)',
    },
    {
      ssrcode: 'LCML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'Low-Calorie Meal',
    },
    {
      ssrcode: 'LFML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'Low Fat Meal',
    },
    {
      ssrcode: 'LPML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname:
        'Low Protein Meal- Contains a restricted quantity of protein, specifically geared for those with liver and kidney ailments. These meals may contain fresh fruit and vegetables, vegetable fats and seasoning, and a measured amount of eggs and meat.',
    },
    {
      ssrcode: 'MOML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname:
        'Muslim Meal- Foods that do not contain any pork, gelatine or alcoholic beverages.',
    },
    {
      ssrcode: 'NBML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'No Beef Meal (on China Airlines)',
    },
    {
      ssrcode: 'NFML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'No Fish Meal (on Lufthansa Airlines)',
    },
    {
      ssrcode: 'NLML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname:
        'No Lactose lactose-free) meal - It excludes milk and dairy products - yogurt, cheese, butter, ice cream, water ice and etc.',
    },
    {
      ssrcode: 'OBML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'Japanese Obento Meal (on United Airlines)',
    },
    {
      ssrcode: 'ORML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname:
        'Oriental Meal- The main course features an “Oriental style” accompanied by beef, pork, chicken, duck, or fish.',
    },
    {
      ssrcode: 'PFML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname:
        'Peanut Free Meal - No peanuts, peanut butter, or other peanut derivative items.',
    },
    {
      ssrcode: 'PRML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'Low Purine Meal - For people struggling with gout.',
    },
    {
      ssrcode: 'RVML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'Raw Vegetable Meal - Only raw vegetables and salads.',
    },
    {
      ssrcode: 'RFML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'Refugee Meal',
    },
    {
      ssrcode: 'SFML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'Seafood Meal- Contains only seafood items',
    },
    {
      ssrcode: 'SPML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'Special Meal - Specify Food',
    },
    {
      ssrcode: 'VGML or VVML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname:
        'Vegetarian Vegan Meal - No animal products, including meat, fish, dairy, eggs, honey.',
    },
    {
      ssrcode: 'VJML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname:
        "Vegetarian Jain Meal - Only fresh fruit and stem vegetables that grow above the ground. It won't contain: animal products/by-products, honey or any root vegetables such as carrots and potatoes.",
    },
    {
      ssrcode: 'VLML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname:
        'Vegetarian Lacto-Ovo Meal - Contains vegetables, fresh fruit, eggs, dairy products. It does not contain any type of fish or meat.',
    },
    {
      ssrcode: 'VOML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname:
        "Vegetarian Oriental Meal - This is a vegetarian meal that is prepared 'Chinese' or 'Oriental' style.",
    },
  ];
  const amedeusMeals = [
    {
      ssrcode: 'BBML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'BABY MEAL',
    },
    {
      ssrcode: 'BLML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'BLAND MEAL',
    },
    {
      ssrcode: 'CHML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'CHILD MEAL',
    },
    {
      ssrcode: 'CNML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'CHICKEN MEAL (LY SPECIFIC)',
    },
    {
      ssrcode: 'DBML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'DIABETIC MEAL',
    },
    {
      ssrcode: 'FPML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'FRUIT PLATTER',
    },
    {
      ssrcode: 'FSML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'FISH MEAL',
    },
    {
      ssrcode: 'GFML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'GLUTEN INTOLERANT MEAL',
    },
    {
      ssrcode: 'HNML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'HINDU (NON VEGETARIAN) MEAL',
    },
    {
      ssrcode: 'IVML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'INDIAN VEGETARIAN MEAL',
    },
    {
      ssrcode: 'JPML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'JAPANESE MEAL',
    },
    {
      ssrcode: 'KSML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'KOSHER MEAL',
    },
    {
      ssrcode: 'LCML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'LOW CALORIE MEAL',
    },
    {
      ssrcode: 'LFML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'LOW FAT MEAL',
    },
    {
      ssrcode: 'LSML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'LOW SALT MEAL',
    },
    {
      ssrcode: 'MOML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'MUSLIM MEAL',
    },
    {
      ssrcode: 'NFML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'NO FISH MEAL (LH SPECIFIC)',
    },
    {
      ssrcode: 'NLML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'LOW LACTOSE MEAL',
    },
    {
      ssrcode: 'OBML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'JAPANESE OBENTO MEAL (UA SPECIFIC)',
    },
    {
      ssrcode: 'RVML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'VEGETARIAN RAW MEAL',
    },
    {
      ssrcode: 'SFML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'SEA FOOD MEAL',
    },
    {
      ssrcode: 'SPML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'SPECIAL MEAL, SPECIFY FOOD',
    },
    {
      ssrcode: 'VGML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'VEGETARIAN VEGAN MEAL',
    },
    {
      ssrcode: 'VJML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'VEGETARIAN JAIN MEAL',
    },
    {
      ssrcode: 'VLML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'VEGETARIAN LACTO-OVO MEAL',
    },
    {
      ssrcode: 'VOML',
      ssrtype: 'meal',
      addedon: '',
      chargeableamount: 0,
      imageurl: 'https://static.iween.co.in/airlinelogos/mealicon.svg',
      currency: cur,
      ssrname: 'VEGETARIAN ORIENTAL MEAL',
    },
  ];

  if (supplier === 'uapi') {
    return uapimeals;
  }

  return amedeusMeals;
}

export default GdsMeals;
